import type { DashboardWidgetConfiguration } from './widget-definition';
import { period } from './query-period';

export const rentalValueWidget: DashboardWidgetConfiguration = {
  widgetId: "rental.value",
  name: "Rental value",
  description: "Rental value for the selected dashboard period.",
  apps: [
    "rental",
  ],
  template: "number",
  query: {
    kind: "single",
    query: {
      version: 1,
      source: "rental.orders",
      ...period(30),
      select: [
        {
          type: "aggregate",
          function: "sum",
          field: "total_amount",
          as: "value",
        },
      ],
    },
  },
  inputs: {
    label: "Rental value",
    subtext: "in the last 30 days",
    icon: "money",
    color: "success",
    valueFormat: "currency",
    valueMultiplier: 1,
  },
  dummyData: {
    value: 0,
    subtext: "Last 30 days",
  },
  limits: {
    minWidth: 2,
    maxWidth: 6,
    minHeight: 1,
    maxHeight: 2,
    defaultWidth: 4,
    defaultHeight: 1,
  },
};
